export class CartScreenModel {
    /**
     * 戻るボタンを左上に出す 1 で有効
     */
    enableBack: string | null = null;
}
